export const palette = {
  /**
   * website colors
   */
  deep_blue: '#274760',
  sky_blue: '#F2FBFF',

  /**
   * nuetrals
   */
  outline: '#E6E6E6',
  underline: '#BDBEC1',

  label: '#58575A',
  border: '#B5B5B5',

  /**
   * alert colors
   */
  confirmation: '#408EDD',
  error: '#EA8722',
  /**
   * ui colors
   */
  ui_blue: '#274760',
  ui_sky_blue: '#F2FBFF',
  ui_blue_light: '#5092C6',
  ui_blue_medium: '#457EAA40',
  ui_text_blue_light: '#32526B',
  ui_text_blue: '#36546B',
  ui_blue_background: '#447DA8',
  ui_disabled: '#AFAFAF',
  ui_grey: '#BDBDBD',
  ui_green: '#02FF20',
  ui_red: '#FF3737',
  ui_bg_light_blue: '#CBEBFB',
  ui_bg_pale_blue: '#F5F8FB',
  ui_bg_sky: '#F6FBFF',
  ui_frost_blue: '#F1F8FB',
  upload_text_blue: '#447DA8',
  
  // Profile specific colors
  profile_rating_bg: '#F3FBFF',
  profile_rating_yellow: '#FFB800',
  profile_bg_light_blue: '#CFE9FF',
  profile_bg_pale_blue: '#DFF4FF',
  profile_border_light_blue: '#D5E9F6',
  profile_feedback_bg: '#F5FBFE',

  ui_link: '#0073EA',


  /**
   * shades
   */
  lightPink: '#FCF5F7',
  toastTint: '#E8F7F6',

  ui_input_border: '#48647966',
  ui_input_border_dark: '#486479',
  ui_user_message_bg: '#486479',
  ui_reply_section: '#F5F8FB',
  ui_form_bg: '#F2F2F2',
  ui_btn_green: '#198F51',
  ui_btn_gray: '#AFAFAF',
  ui_bootom_border: '#CDD0D2',
  ui_button_red: '#FF0808',
  ui_text_black: '#121212',
  dashboardBackground: '#F9FAFB',
  rejection: '#E23B3B',
  disabled: '#C8C8C8',
  grey: '#807F81',
  grey_dark: '#828282',
  black: '#07020D',
  white: '#FFFFFF',
  statusbggreen: '#198F51',
  dark_orange:'#D8650D',
  fade_orange:'#F18D00',
  light_green:'#00B70C',
  pearl_blue:'#5092C6',

  ui_placeholder: '#60717F',

  // action colors
  new: "#FFD633",
  in_progress: "#FFAF46",
  completed: "#198F51",
  cancel: "#F05B5B",
  
  action_text: "#39341F",
};
